import FlatList from 'flatlist-react'
import { AddedCodes } from './components/AddedCodes/AddedCodes'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getAddedCodes(codes, deleteCode) {
  return (
    <FlatList
      displayGrid
      minColumnWidth='114px'
      list={codes}
      // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
      renderItem={(item, index) => <AddedCodes code={item} deleteCode={deleteCode} />}
    />
  )
}
